module.exports = __webpack_public_path__ + "img/ie.1c12635a.svg";